import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { ECGResultsContainer } from '../../../common/types/ECGResults';

import { ECGPreview } from './ECGPreview';

interface ECGPreviewButtonProps {
  data: string; // JSON string containing ECGResults
}

export const ECGPreviewButton: React.FC<ECGPreviewButtonProps> = ({ data }) => {
  const [showModal, setShowModal] = useState(false);
  const [ecgResults, setEcgResults] = useState<ECGResultsContainer | null>(
    null,
  );

  const handleClick = () => {
    try {
      const parsed = JSON.parse(data) as ECGResultsContainer;
      setEcgResults(parsed);
      setShowModal(true);
    } catch (error) {
      console.error('Error parsing ECG results:', error);
    }
  };

  return (
    <>
      <OverlayTrigger overlay={<Tooltip>Podgląd wyniku EKG</Tooltip>}>
        <Button
          onClick={e => {
            e.stopPropagation();
            handleClick();
          }}
          variant="btn-info"
          size="sm"
        >
          <Icon.Eye />
        </Button>
      </OverlayTrigger>
      {ecgResults && (
        <ECGPreview
          show={showModal}
          onHide={() => setShowModal(false)}
          results={ecgResults}
        />
      )}
    </>
  );
};
